import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DuplicateIcon = (props: IconProps) => (
  <Icon fill="currentColor" viewBox="0 0 16 16" title={t`Duplicate`} {...props}>
    <Rect
      x="7"
      y="7"
      width="7"
      height="7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={"none"}
    />
    <Path
      d="M8 4V2H2V8H4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={"none"}
    />
  </Icon>
);
